import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS, API_BASE_URL_DOCS } from "../../../../config/api";

const ViewProposal = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);

  const [proposal, setProposal] = useState(null);
  const [departments, setDepartments] = useState([]);

  // ===============================
  // CARGAR PROPUESTA
  // ===============================

  useEffect(() => {

    const loadProposal = async () => {

      const res = await authFetch(`${ENDPOINTS.getProposalById}?id=${id}`);

      if (res.success) {
        setProposal(res.data);
      }

    };

    loadProposal();

  }, [id, authFetch]);

  // ===============================
  // CARGAR DEPARTAMENTOS
  // ===============================

  useEffect(() => {

    const loadDepartments = async () => {

      const res = await authFetch(ENDPOINTS.getDepartmentCol);

      if (res.success) {
        setDepartments(res.data);
      }

    };

    loadDepartments();

  }, [authFetch]);

  if (!proposal) return <p>Cargando propuesta...</p>;

  // ===============================
  // CONVERTIR IDS A NOMBRES
  // ===============================

  let departmentNames = [];

  if (proposal.department && departments.length > 0) {

    try {

      const depArray = Array.isArray(proposal.department)
        ? proposal.department
        : JSON.parse(proposal.department);

      departmentNames = depArray.map((id) => {

        const dep = departments.find(
          (d) => String(d.id_departamento) === String(id)
        );

        return dep ? dep.nombre : id;

      });

    } catch (error) {
      departmentNames = [];
    }

  }

  return (

    <div className="container mt-4 p-4">

      <div className="d-flex justify-content-between mb-4">

        <h3>Detalle de Propuesta</h3>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left me-1"></i> Volver
        </button>

      </div>

      <div className="card p-4 shadow-sm">

        <p><b>Entidad:</b> {proposal.entidad}</p>
        <p><b>Tipo población:</b> {proposal.type_population}</p>
        <p><b>Objeto:</b> {proposal.object}</p>

        <p>
          <b>Departamentos:</b>{" "}
          {departmentNames.length > 0
            ? departmentNames.join(", ")
            : "No especificado"}
        </p>

        <p><b>Municipios:</b> {proposal.municipality}</p>
        <p><b>Fecha inicio:</b> {proposal.start_date}</p>
        <p><b>Fecha fin:</b> {proposal.end_date}</p>

        <p><b>Presupuesto presencia:</b> ${proposal.presupuesto_presencia}</p>
        <p><b>Presupuesto entidad:</b> ${proposal.presupuesto_entity}</p>

        <hr />

        <h5>Documentos</h5>

        <div className="d-flex gap-3 flex-wrap mt-3">

          {proposal.doc_contratante && (
            <a
              href={`${API_BASE_URL_DOCS}${proposal.doc_contratante}`}
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-pink"
            >
              Documento contratante
            </a>
          )}

          {proposal.doc_propuesta_presencia && (
            <a
              href={`${API_BASE_URL_DOCS}${proposal.doc_propuesta_presencia}`}
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-purple"
            >
              Propuesta presencia
            </a>
          )}

          {proposal.doc_evaluacion_propuesta && (
            <a
              href={`${API_BASE_URL_DOCS}${proposal.doc_evaluacion_propuesta}`}
              target="_blank"
              rel="noreferrer"
              className="btn btn-secondary"
            >
              Evaluación propuesta
            </a>
          )}

        </div>

      </div>

    </div>

  );

};

export default ViewProposal;